import React, {useContext} from 'react';
import {Route, Redirect} from 'react-router-dom';
import {AuthContext} from '../../contexts/auth/context';
import {AuthContextType} from '../../contexts/auth/types';
import {ExclusiveRouteType} from '../../enums/exclusive-route-type';
import {ScreenPaths} from '../../enums/screen-path';

interface Props {
  exact?: boolean;
  path: string;
  type: ExclusiveRouteType;
  children: React.ReactNode;
}

/**
 * HOC used to define each one of our exclusive routes. We have the following:
 * - System administrator (routes under /system-administrator)
 * - Partner (routes under /partner)
 * - Professional caregiver (routes under /professional-caregiver)
 * - Informal caregiver (routes under /informal-caregiver)
 * - Me (routes under /me)
 */
const ExclusiveRoute: React.FC<Props> = ({children, ...rest}) => {
  // Get context
  const authContext: AuthContextType = useContext(AuthContext);

  return (
    <Route
      {...rest}
      render={({location}) =>
        (rest.type === ExclusiveRouteType.SystemAdministrator &&
          authContext.state.session &&
          authContext.state.session.systemAdministratorProfile) ||
        (rest.type === ExclusiveRouteType.Partner &&
          authContext.state.session &&
          authContext.state.session.partnerProfile) ||
        (rest.type === ExclusiveRouteType.ProfessionalCaregiver &&
          authContext.state.session &&
          authContext.state.session.affiliations.length > 0) ||
        (rest.type === ExclusiveRouteType.InformalCaregiver &&
          authContext.state.session &&
          authContext.state.session.relationships.length > 0) ||
        rest.type === ExclusiveRouteType.Me ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: ScreenPaths.Office,
            }}
          />
        )
      }
    />
  );
};
export default ExclusiveRoute;
